'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _CommonLayout = require('./CommonLayout');

var _CommonLayout2 = _interopRequireDefault(_CommonLayout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        StartupLayout: _CommonLayout2.default
    },
    data: function data() {
        return {
            network: null,
            network_extras: null,
            username: '',
            password: '',
            znc_network: '',
            showNetwork: true,
            showPass: true,
            showUser: true,
            show_password_box: false
        };
    },
    computed: {
        greetingText: function greetingText() {
            var greeting = _state2.default.settings.startupOptions.greetingText;
            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
        },
        buttonText: function buttonText() {
            var greeting = _state2.default.settings.startupOptions.buttonText;
            return typeof greeting === 'string' ? greeting : this.$t('start_button');
        },
        readyToStart: function readyToStart() {
            return this.username && (this.password || this.showPass === false);
        },
        infoContent: function infoContent() {
            return _state2.default.settings.startupOptions.infoContent || '';
        }
    },
    created: function created() {
        var options = _state2.default.settings.startupOptions;

        this.username = options.username || '';
        this.password = options.password || '';
        this.znc_network = window.location.hash.substr(1) || options.network || '';
        this.showNetwork = typeof options.showNetwork === 'boolean' ? options.showNetwork : true;
        this.showUser = typeof options.showUser === 'boolean' ? options.showUser : true;
        this.showPass = typeof options.showPass === 'boolean' ? options.showPass : true;

        if (options.autoConnect && this.username && this.password) {
            this.startUp();
        }
    },
    methods: {
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },

        formSubmit: function formSubmit() {
            if (this.readyToStart) {
                this.startUp();
            }
        },
        addNetwork: function addNetwork(netName) {
            var options = _state2.default.settings.startupOptions;
            var password = this.username;
            if (netName) {
                password += '/' + netName;
            }
            password += ':' + this.password;

            var net = _state2.default.addNetwork(netName, 'ZNC', {
                server: _lodash2.default.trim(options.server),
                port: options.port,
                tls: options.tls,
                password: password
            });
            return net;
        },
        startUp: function startUp() {
            var _this = this;

            if (this.network) {
                _state2.default.removeNetwork(this.network.id);
            }

            var netList = _lodash2.default.compact(this.znc_network.split(','));
            if (netList.length === 0) {
                netList.push('');
            }

            var net = this.network = this.addNetwork(netList.shift());
            this.network_extras = netList;

            var onRegistered = function onRegistered() {
                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
                _this.network_extras.forEach(function (netName, idx) {
                    var extraNet = _this.addNetwork(_lodash2.default.trim(netName));
                    extraNet.ircClient.connect();
                });
                _this.$refs.layout.close();
            };
            var onClosed = function onClosed() {
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
            };
            net.ircClient.once('registered', onRegistered);
            net.ircClient.once('close', onClosed);
            net.ircClient.connect();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["ZncLogin"]
window._kiwi_exports.components.startups.ZncLogin = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/startups/ZncLogin.vue
// module id = niD1
// module chunks = 1